var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list1}},[_c('el-table-column',{attrs:{"prop":"sex","label":"性别","width":"180"}}),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","width":"180"}}),_c('el-table-column',{attrs:{"prop":"age","label":"年龄"}})],1),_c('el-button',{on:{"click":_vm.add}},[_vm._v("测试")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }